import * as buttons from './Button';
import { ButtonGroup } from './ButtonGroup';
import { ButtonClipboardBabyPrimary, ButtonClipboardBabySecondary, ButtonClipboardPrimary, ButtonClipboardSecondary } from './ClipboardButton';
import { ButtonWrapper } from './GenericButton';
import { ButtonIconOnly } from './IconButton';
export var Button = {
  Primary: buttons.ButtonPrimary,
  Secondary: buttons.ButtonSecondary,
  /** @deprecated */
  Red: buttons.ButtonRed,
  BabyPrimary: buttons.ButtonBabyPrimary,
  BabySecondary: buttons.ButtonBabySecondary,
  /** @deprecated */
  BabyRed: buttons.ButtonBabyRed,
  SubtlePrimary: buttons.ButtonSubtlePrimary,
  SubtleSecondary: buttons.ButtonSubtleSecondary,
  /** `Button.Text` components look like links, but behave like buttons. */
  TextPrimary: buttons.ButtonTextPrimary,
  /** `Button.Text` components look like links, but behave like buttons. */
  TextSecondary: buttons.ButtonTextSecondary,
  ClipboardPrimary: ButtonClipboardPrimary,
  ClipboardSecondary: ButtonClipboardSecondary,
  ClipboardBabyPrimary: ButtonClipboardBabyPrimary,
  ClipboardBabySecondary: ButtonClipboardBabySecondary,
  IconOnly: ButtonIconOnly,
  /**
   * Divs and spans with onClick handlers should be wrapped by this element
   * and the onClick handler should be moved up to this element.
   * This wrapper prevents the child element from being focusable
   * and instead adds a focus outline to the child element when the button has focus.
   * This is to only show the focus outline when tabbing to the element
   * and not when clicking the element.
   */
  Wrapper: ButtonWrapper,
  /**
   * Wrap multiple buttons in this component to apply standard padding between them.
   */
  Group: ButtonGroup
};